import $ from 'zepto'

let loaded = {}
let $body = $('body')
let src = 'https://cdn.gegejia.com/core/gjsapi/1.5.4/gjsapi.min.js'

export function loadBanmaSdk () {
  return new Promise((resolve, reject) => {
    if (loaded[src]) {
      return resolve()
    }

    var script = $('<script />')
    script.on('load', function () {
      loaded[src] = true
      resolve()
    })
    script.on('error', function (error) {
      reject(error)
    })
    script.attr('src', src)
    script.appendTo($body)
  })
}



// WEBPACK FOOTER //
// ./src/mods/banmaApi.js